import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['container', 'assetItem', 'destroyField']

  addAsset(event) {
    event.preventDefault()

    const timestamp = new Date().getTime()
    const template = this.assetItemTargets[0]

    if (!template) return

    const newItem = template.cloneNode(true)

    // Update field names and IDs with unique timestamp
    newItem.querySelectorAll('input, select, textarea').forEach(input => {
      const name = input.name.replace(/\[\d+\]/, `[${timestamp}]`)
      const id = input.id.replace(/_\d+_/, `_${timestamp}_`)
      input.name = name
      input.id = id

      // Clear values except for kind field
      if (!input.name.includes('[kind]')) {
        input.value = input.name.includes('_destroy') ? '0' : ''
      }
    })

    // Clear image preview
    const mediaContainer = newItem.querySelector('[data-media-library-target="mediaContainer"]')
    if (mediaContainer) {
      mediaContainer.innerHTML = '<div class="text-muted">No image selected</div>'
    }

    // Show select button, hide replace/remove buttons
    const selectButton = newItem.querySelector('[data-media-library-target="selectMediaButton"]')
    if (selectButton) selectButton.classList.remove('hidden')

    this.containerTarget.appendChild(newItem)
  }

  removeAsset(event) {
    event.preventDefault()

    const item = event.target.closest('[data-multiple-assets-target="assetItem"]')
    const destroyField = item.querySelector('[data-multiple-assets-target="destroyField"]')

    const idField = item.querySelector('input[name*="[id]"]')
    if (destroyField && idField?.value) {
      // Existing record: mark for destruction
      destroyField.value = '1'
      item.style.display = 'none'
    } else {
      // New record: remove from DOM
      item.remove()
    }
  }
}
